import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { Link } from 'foundations-components/transitional/components/Link';
import styled from 'styled-components';
import { tracker } from '../../_core/common/eventTracking/tracker';
import TableBodyFeatureGroup from './TableBodyFeatureGroup';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ProductsAndServicesCatalogTD = styled(View)(({
  theme
}) => ({
  // TODO: Need to evaluate approach to handling consistent row sizing
  height: '74px',
  padding: theme.space['400'],
  borderTop: `${theme.borderWidth['100']} solid ${theme.color['border-core-subtle']}`
}));
const StyledTD = styled(View)(({
  theme
}) => ({
  borderTop: `${theme.borderWidth['100']} solid ${theme.color['border-core-subtle']}`
}));
const TableBody = ({
  apiNames,
  tableBodyData
}) => {
  const trackProductsAndServicesCatalogClick = () => {
    tracker.track('interaction', {
      action: 'clicked-products-and-services-catalog-link'
    });
  };
  return /*#__PURE__*/_jsxs(View, {
    as: "tbody",
    children: [/*#__PURE__*/_jsx(View, {
      as: "tr",
      children: /*#__PURE__*/_jsx("td", {
        colSpan: apiNames.length + 1,
        children: /*#__PURE__*/_jsx(Text, {
          typography: "heading-600",
          paddingInlineStart: "400",
          paddingBlockStart: "1000",
          paddingBlockEnd: "700",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "upgrades.featureTableMC0672.useCases.buildPipelines"
          })
        })
      })
    }), /*#__PURE__*/_jsx(TableBodyFeatureGroup, {
      apiNames: apiNames,
      groupFeatures: tableBodyData.buildPipelines
    }), /*#__PURE__*/_jsx(View, {
      as: "tr",
      children: /*#__PURE__*/_jsx(StyledTD, {
        as: "td",
        colSpan: apiNames.length + 1,
        children: /*#__PURE__*/_jsx(Text, {
          typography: "heading-600",
          paddingInlineStart: "400",
          paddingBlockStart: "1000",
          paddingBlockEnd: "700",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "upgrades.featureTableMC0672.useCases.closeDeals"
          })
        })
      })
    }), /*#__PURE__*/_jsx(TableBodyFeatureGroup, {
      apiNames: apiNames,
      groupFeatures: tableBodyData.closeDeals
    }), /*#__PURE__*/_jsx(View, {
      as: "tr",
      children: /*#__PURE__*/_jsx(StyledTD, {
        as: "td",
        colSpan: apiNames.length + 1,
        children: /*#__PURE__*/_jsx(Text, {
          typography: "heading-600",
          paddingInlineStart: "400",
          paddingBlockStart: "1000",
          paddingBlockEnd: "700",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "upgrades.featureTableMC0672.useCases.customerPlatform"
          })
        })
      })
    }), /*#__PURE__*/_jsx(TableBodyFeatureGroup, {
      apiNames: apiNames,
      groupFeatures: tableBodyData.customerPlatform
    }), /*#__PURE__*/_jsx(View, {
      as: "tr",
      children: /*#__PURE__*/_jsx(ProductsAndServicesCatalogTD, {
        as: "td",
        colSpan: apiNames.length + 1,
        children: /*#__PURE__*/_jsx(Text, {
          typography: "body-100",
          children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
            message: "upgrades.productsAndServicesCatalogLink_jsx",
            elements: {
              Link
            },
            options: {
              onClick: () => trackProductsAndServicesCatalogClick()
            }
          })
        })
      })
    })]
  });
};
export default TableBody;